export default __webpack_public_path__ + "static/circle-jp-flag-00ec3ea4ed47125afaa6c322d79e5e33.svg";